import {UserAvatar} from '@frontend/components/UserAvatar'
import clsx from 'clsx'
import {useState} from 'react'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {trans} from '../../../../helpers'

// Сколько правил видно, пока сообщение свернуто.
const collapsedRulesCount: number = 2

interface Props {
    // Мобильная раскладка независимо от ширины экрана.
    miniChat?: boolean
}

// Системное сообщение от Dotoku с правилами общения в чате.
export function ChatBehaviorWarning(props: Props) {

    const {miniChat} = props

    const [
        isExpanded,
        setIsExpanded,
    ] = useState<boolean>(false)

    const rules: string[] = trans().cabinet.chats.behavior_rules

    return (
        <div
            className={clsx(
                'chat-message d-flex flex-column align-items-start gap-2 mb-3 pe-5',
                !miniChat && 'flex-sm-row'
            )}
        >
            {!miniChat && (
                <UserAvatar
                    userName={null}
                    fallbackContent={(
                        <img
                            src="/img/favicon.svg"
                            alt="Dotoku"
                            width={24}
                            height={24}
                        />
                    )}
                    className="chat-surface flex-center flex-shrink-0"
                />
            )}
            <div className="chat-message-text chat-surface p-3 rounded-8 d-flex flex-column align-items-start gap-3">
                {(isExpanded ? rules : rules.slice(0, collapsedRulesCount)).map((rule: string) => (
                    <div key={rule}>
                        {rule}
                    </div>
                ))}
                {isExpanded && (
                    <div>
                        {trans().cabinet.chats.behavior_rules_footer}
                    </div>
                )}
                <Button
                    color="link"
                    className="link-blue p-0"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? trans().cabinet.chats.hide_rules : trans().cabinet.chats.show_all_rules}
                </Button>
            </div>
        </div>
    )
}
